import cn from 'classnames';
import { animated, useTrail, config } from 'react-spring';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { IOptionItem, ITopPlayerItem } from '../interfaces';
import { formatThousandNumber } from '@utils/utils';
import styles from './top-item.module.scss';
import Dropdown from './dropdown';

const formatExperience = (experience: number): string => {
    const expString: string = experience.toString();

    if (expString.length <= 3) return expString;

    const unit: 'K' | 'M' =
        expString.length > 3 && expString.length <= 6 ? 'K' : 'M';

    return `${expString.charAt(0)},${expString.charAt(1)}${unit}`;
};
interface IProps {
    playerBackground: 'yellow-gradient' | 'green-gradient';
    options: IOptionItem[];
    players: ITopPlayerItem[];
    title: string;
    value: string;
    // eslint-disable-next-line no-unused-vars
    onChange: (value: string) => void;
}

const TopItem = ({
    playerBackground,
    options,
    players,
    title,
    value,
    onChange,
}: IProps): JSX.Element => {
    console.log(options, value, onChange);

    /* Animations */

    const playersStaggeredAnimation = useTrail(players.length, {
        from: { opacity: 0, transform: 'translateX(-100%) scale(0)' },
        to: { opacity: 1, transform: 'translateX(0px) scale(1)' },
        config: config.gentle,
        delay: 1000,
    });

    /* ClassNames */

    const playerClassNames: string = cn(styles.player, {
        [styles[`player-bg-${playerBackground}`]]: playerBackground,
    });

    /* Components */

    const TopPlayers: JSX.Element[] = players.map((player, idx) => (
        <article key={idx} className={playerClassNames}>
            {/* User info */}

            <div className={styles.data}>
                <span className={styles.data__position}>{idx + 1}</span>
                <span className={styles.data__greenCircle} />
                <figure className={styles.data__avatar}>
                    <img
                        src={player.user.avatar_url}
                        alt={player.user.username}
                    />
                </figure>
                <p className={styles.data__username}>{player.user.username}</p>
            </div>

            {/* Stats */}

            {player.earnings && (
                <div className={styles.stats__earnings}>
                    <CoinIcon />
                    <span>{formatThousandNumber(player.earnings)}</span>
                </div>
            )}

            {player.experience && (
                <p className={styles.stats__experience}>
                    {formatExperience(player.experience)} <small>XP</small>
                </p>
            )}

            {player.level && (
                <span className={styles.stats__level}>{player.level}</span>
            )}
        </article>
    ));

    const AnimatedTopPlayers: JSX.Element[] = playersStaggeredAnimation.map(
        (style, idx) => (
            <animated.div key={idx} {...{ style }}>
                {TopPlayers[idx]}
            </animated.div>
        ),
    );

    return (
        <div className={styles.item}>
            <header className={styles.item__header}>
                <h4>{title}</h4>
                <Dropdown {...{ options, onChange }} />
            </header>
            <section className={styles.item__content}>
                {AnimatedTopPlayers}

                <button type="button" className={styles['item__see-more']}>
                    See more
                </button>
            </section>
        </div>
    );
};

export default TopItem;
